import axios from "axios";
import React from "react";

import HalftimeChart1 from "./halftime_chart1";
import { Chart } from "primereact/chart";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { Link } from "react-router-dom";

import { translate } from "react-i18next";

import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// See https://facebook.github.io/react/docs/forms.html for documentation about forms.
class TestPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  actionTemplate(rowData, column) {
    console.log("column", column);
    console.log("rowData", rowData);

    return (
      <div>
        <span>&#8213;</span>
        <Chart type="horizontalBar" data={this.state.bardata} />
      </div>
    );
  }
  actionTemplate2(rowData, column) {
    return <HalftimeChart1 name="name1" count="4" starttime="9" />;
  }
  componentDidMount() {
    axios.get("https://ps-app-test.herokuapp.com/user/all").then(res => {
      const users = res.data;
      this.setState({ users });
    });

    const bardata = {
      labels: ["a", "b", "c", "d", "e"],
      datasets: [
        {
          label: "first",
          backgroundColor: "#42A5F5",
          data: [25, 20, 15, 10, 0]
        },
        {
          label: "second",
          backgroundColor: "#9CCC65",
          data: [30, 26, 22, 15, 7]
        }
      ]
    };
    this.setState({ bardata });
  }

  // for html conversion
  createMarkup(text) {
    return { __html: text };
  }

  //<Column body={this.actionTemplate.bind(this)} header="Actions" />
  render() {
    const { t } = this.props;

    return (
      <div className="container marketing no-banner">
        <div className="page-header">
          <div className="btn-toolbar pull-right">
            <div className="btn-group" />
          </div>
          <h3>Test page prime react table and charts</h3>
        </div>

        <div>
          <DataTable value={this.state.users}>
            <Column body={this.actionTemplate2.bind(this)} header="Halftime" />
            <Column field="firstname" header="drug" />
            <Column field="lastname" header="..." />
          </DataTable>
        </div>
        <Chart type="horizontalBar" data={this.state.bardata} />
        <br />
        <br />
        <HalftimeChart1 name="name3" count="4" starttime="9" />
      </div>
    );
  }
}

export default translate()(TestPage);
